<template>
  <v-container fluid>
    <v-tabs v-model="currentTab" dark class="pl-3 pr-3">
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="tabConfig in tabsConfig"
        :key="tabConfig.name"
        :href="`#${tabConfig.name}`"
      >
        {{ tabConfig.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab" dark>
      <v-tab-item
        v-for="tabConfig in tabsConfig"
        :key="tabConfig.name"
        :value="tabConfig.name"
      >
        <v-card flat style="background-color: #272b30">
          <component
            :is="tabConfig.component"
            :products-data="productsData"
            :loading="loading"
            @refresh-data="loadProductManagementData"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Products from "../ProductManagement/Products/products.vue";
import ProductsOption from "../ProductManagement/ProductOptions/productOptions.vue";
import Categories from "../ProductManagement/Categories/categories.vue";
import EventTags from "../ProductManagement/Tags/eventTags.vue";
import Layouts from "../ProductManagement/Layouts/Layouts.vue";

export default {
  components: {
    Products,
    ProductsOption,
    Categories,
    EventTags,
    Layouts,
  },
  data() {
    return {
      tabsConfig: [
        { name: "Categories", label: "Categories", component: "Categories" },
        { name: "Tags", label: "Tags", component: "EventTags" },
        { name: "Products", label: "Products", component: "Products" },
        {
          name: "ProductsOptions",
          label: "Products Options",
          component: "ProductsOption",
        },
        { name: "Layouts", label: "Layouts", component: "Layouts" },
      ],
      productsData: {
        products: [],
        productCategories: [],
        stallholderTags: [],
        eventTags: [],
        productOptions: [],
        layouts: [],
      },
      loading: false,
    };
  },
  computed: {
    ...mapState("admin", ["currentProductManagementTab"]),
    ...mapState("filter", ["globalEventFilter"]),
    ...mapState("admin", ["currentStallholder"]),
    currentTab: {
      get() {
        return this.currentProductManagementTab;
      },
      set(value) {
        this.setCurrentProductManagementTab(value);
      },
    },
  },
  watch: {
    "globalEventFilter.EventId"(newVal) {
      if (newVal) {
        this.loadProductManagementData();
      }
    },
    currentStallholder: {
      handler(newStallholder) {
        if (newStallholder) {
          this.loadProductManagementData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("admin", ["setCurrentProductManagementTab"]),
    ...mapActions("admin", ["getProducts", "getLayouts"]),

    async loadProductManagementData() {
      if (
        !this.globalEventFilter.EventId ||
        !this.currentStallholder?.StallholderId
      ) {
        this.resetProductsData();
        return;
      }

      this.loading = true;

      try {
        const paramObj = {
          EventId: this.globalEventFilter.EventId,
          StallholderId: this.currentStallholder.StallholderId,
        };

        // Load products data (includes categories, tags, product options)
        const productsResponse = await this.getProducts(paramObj);

        const paramLayoutObj = {
          eventId: this.globalEventFilter.EventId,
          stallholderId: this.currentStallholder.StallholderId,
        };

        // Load layouts data
        const layoutsResponse = await this.getLayouts(paramLayoutObj);

        this.productsData = {
          products: productsResponse.Products || [],
          productCategories: productsResponse.ProductCategories || [],
          stallholderTags: productsResponse.StallholderTags || [],
          eventTags: productsResponse.EventTags || [],
          productOptions: productsResponse.ProductOptions || [],
          layouts: layoutsResponse.Layouts || [],
        };
      } catch (error) {
        console.error("Error loading product management data:", error);
        this.resetProductsData();
      } finally {
        this.loading = false;
      }
    },

    resetProductsData() {
      this.productsData = {
        products: [],
        productCategories: [],
        stallholderTags: [],
        eventTags: [],
        productOptions: [],
        layouts: [],
      };
    },
  },
};
</script>

<style scoped>
body {
  background-color: #272b30;
}
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
p {
  color: #6e6e6e;
  font-family: sans-serif;
}
</style>
